export default __webpack_public_path__ + "static/media/apple.9f832255.png";